import React from "react";

/**
 * "Your MoneyMind Persona Chart" — five practical dimensions, each a bar
 * (level 1–5) with a visible level label so meaning never depends on color.
 * Values are persona tendencies from the quiz, not account or credit data.
 */
export const PersonaChart = ({ chart, color }) => {
  if (!chart) return null;
  return (
    <section className="mt-12" data-testid="result-persona-chart">
      <p className="eyebrow text-[#2F6F8F]">How you tend to handle money</p>
      <h2 className="font-serif text-3xl sm:text-4xl text-[#2C302E] mt-2 leading-tight">
        {chart.title}
      </h2>
      <p className="mt-4 text-[#4d4f4c] leading-relaxed max-w-2xl" data-testid="result-persona-chart-summary">
        {chart.summary}
      </p>

      <div className="mt-8 bg-white border border-[#E6E3DB] p-6 sm:p-8 space-y-6">
        {chart.dimensions.map((d) => (
          <div key={d.key} data-testid={`result-chart-${d.key}`}>
            <div className="flex items-baseline justify-between gap-4">
              <p className="font-semibold text-[#2C302E]">{d.label}</p>
              <span
                className="text-xs font-semibold uppercase tracking-wider"
                style={{ color }}
                data-testid={`result-chart-${d.key}-level`}
              >
                {d.level_label}
              </span>
            </div>
            <div
              className="mt-2 grid grid-cols-5 gap-1"
              role="img"
              aria-label={`${d.label}: ${d.level_label}, ${d.level} of 5`}
            >
              {[1, 2, 3, 4, 5].map((n) => (
                <span
                  key={n}
                  className="h-2 rounded-sm"
                  style={{ background: n <= d.level ? color : "#EAE7DF" }}
                />
              ))}
            </div>
            <p className="mt-2 text-sm text-[#4d4f4c] leading-relaxed">{d.note}</p>
          </div>
        ))}
      </div>

      <p className="mt-3 text-xs text-[#787671] leading-relaxed max-w-2xl" data-testid="result-persona-chart-disclaimer">
        {chart.disclaimer}
      </p>
    </section>
  );
};
